import React, { Component } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { Avatar, Button, CssBaseline, TextField, Grid, Typography, CircularProgress, Container } from '@mui/material';
import { QueuePlayNext, DeleteForever } from '@mui/icons-material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import Api from '../../services/api';
import CustomizedSnackbars from '../../components/material-snackbars';
import Dropzone from 'react-dropzone';
import HeaderMenu from '../../components/header-menu';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';import SimpleSelect from '../../components/select/simple';
import SimpleAutoComplete from '../../components/auto-complete/autocomplete';
import Footer from '../../components/footer';
import { browserHistory } from '../../helpers/history';
import Title from '../../components/title-name';
import * as Service from '../../services/techinicalteamorganizationcategory.service';
import * as componentActions from '../../redux/actions/techinicalteamorganizationcategories';

import { FormattedMessage,injectIntl } from 'react-intl';

class TechinicalTeamOrganizationCategoryEdit extends Component {

  
  constructor(props) {
    super(props);
            const { userSession,techinicalteamorganizationcategories } = this.props;
   

    this.globalAdm = false;
    this.isClient = true;
    if(userSession == null ||  userSession.user == null || userSession.user.userrole == null){
      Api.logoff();
    }
    
    if(!techinicalteamorganizationcategories || (techinicalteamorganizationcategories && !techinicalteamorganizationcategories.techinicalteamorganizationcategory)) {
      var l = this.props.match.params.lang;
      document.location.href=`/${l}/calleds`
    }

    userSession.user.userrole.map((item, key) => {
            if(item.role.roletype !=3){
                this.isClient = false;
            }
            if(item.role.roletype ==0){
              this.globalAdm =true;
            }
        }
    );

    // console.log(techinicalteamorganizationcategories.techinicalteamorganizationcategory);
    this.initialState = {
      UpdatedUser: userSession.user.id,
       id: techinicalteamorganizationcategories.techinicalteamorganizationcategory.id,
     OrganizationCategoryId:  techinicalteamorganizationcategories.techinicalteamorganizationcategory.organizationcategory,
     OrganizationCategoryText: techinicalteamorganizationcategories.techinicalteamorganizationcategory.OrganizationCategoryText,
     TechinicalTeamId:  techinicalteamorganizationcategories.techinicalteamorganizationcategory.TechinicalTeamId,
     TechinicalTeamText: techinicalteamorganizationcategories.techinicalteamorganizationcategory.TechinicalTeamText,
     OrganizationId:  techinicalteamorganizationcategories.techinicalteamorganizationcategory.organization.id,
     OrganizationText: techinicalteamorganizationcategories.techinicalteamorganizationcategory.organization.name, 

     };         
    this.state = {
      techinicalteamorganizationcategory: this.initialState,

      files: [],
      loading: true,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: '',
      OrganizationCategoryList: [],
      TechinicalTeamList: [],
      OrganizationList: [],
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
    this.changeValues = this.changeValues.bind(this);
  }

  componentWillReceiveProps(nextProps){
                        if(nextProps.location.state === "reload"){
                            this.componentDidMount();
                        }
                    }    

    async componentDidMount() {
        await this.getOrganizations();

        await this.getCategories(this.state.techinicalteamorganizationcategory.OrganizationId);
        await this.getTechinicalTeams(this.state.techinicalteamorganizationcategory.OrganizationId);
     };
     async getCategories(OrganizationId){
          var result = await Service.getAllCategoriesWithParentByOrganization(OrganizationId);
            if (result.success) {
              this.setState({ loading: false, OrganizationCategoryList: result.data });
                            
            } else {
              const intl = this.props.intl;
              this.setState({
                loading: false, openNotification: true, notificationVariant: 'error',
                notificationMessage: result.response && result.response.data && result.response.data.errors &&  result.response.data.errors[0] ? result.response.data.errors[0] : intl.formatMessage({id:"process.error"})
              });
              Api.kickoff(result);  
            }
  };     
  async getTechinicalTeams(OrganizationId){
          var result = await Service.getTechinicalTeamsByOrganization(OrganizationId);
            if (result.success) {
              this.setState({  TechinicalTeamList: result.data });
                            
            } else {
              const intl = this.props.intl;
              this.setState({
                 openNotification: true, notificationVariant: 'error',
                notificationMessage: result.response && result.response.data && result.response.data.errors &&  result.response.data.errors[0] ? result.response.data.errors[0] : intl.formatMessage({id:"process.error"})
              });
              Api.kickoff(result);  
            }
  };

  async getOrganizations(){
    this.setState({ loading: true });
    var result = await Service.getOrganizations();
      if (result.success) {
        this.setState({ loading: false, OrganizationList: result.data });
                      
      } else {
        const intl = this.props.intl;
        this.setState({
          loading: false, openNotification: true, notificationVariant: 'error',
          notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({id:"process.error"})
        });
        Api.kickoff(result);  
      }
};  
  
  handleInputChange(e) {
    const name = e.target.name;
    const value = e.target.value;

    this.setState(prevState => ({
      techinicalteamorganizationcategory: {
        ...prevState.techinicalteamorganizationcategory,
        [name]: value
      }
    }));
  };

  handleSubmit = async e => {
    e.preventDefault();
    const defaultvalue = {id:0, name:''};

    // console.log(this.state);

    this.setState({ loading: true });

    let data = new FormData();


      if (this.isClient) {
        this.setState(prevState => ({
          techinicalteamorganizationcategory: {
            ...prevState.techinicalteamorganizationcategory,
          }
        }));
      } else {
        this.setState(prevState => ({
          techinicalteamorganizationcategory: {
            ...prevState.techinicalteamorganizationcategory,
          }
        }));
      }


      for (let key in this.state.techinicalteamorganizationcategory) {
        if (key.toString().toLowerCase().indexOf('_date') > -1 || key.toString().toLowerCase().indexOf('date_') > -1) {
          data.append(key, moment(this.state.techinicalteamorganizationcategory[key]).format('YYYY/MM/DD HH:mm:ss'));
        } 
        else if (key.toString().toLowerCase().indexOf('organizationcategoryid') > -1) {
          // console.log(this.state.techinicalteamorganizationcategory[key]);
          data.append('OrganizationCategory',this.state.techinicalteamorganizationcategory[key]);
          data.append(key, this.state.techinicalteamorganizationcategory[key].id);
        }
        else {
          data.append(key, this.state.techinicalteamorganizationcategory[key]);
        }
      }

      //OrganizationCategoryList.find(x => x.id === '45').foo;

      this.state.files.forEach(file => data.append('filesUpload', file));
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
        Api.put('/techinicalteamorganizationcategories', data, config)

        .then(result => {
          if (result.data.success) {
        const formattedList = result.data.data;
        formattedList.OrganizationCategoryId=  formattedList.organizationcategory ? formattedList.organizationcategory : defaultvalue;
        formattedList.OrganizationCategoryText=  formattedList.organizationcategory ? formattedList.organizationcategory.name : '';
        formattedList.TechinicalTeamId=  formattedList.techinicalteam ? formattedList.techinicalteam.id : 0;
        formattedList.TechinicalTeamText=  formattedList.techinicalteam ? formattedList.techinicalteam.name : '';
        formattedList.OrganizationId = formattedList.organization ? formattedList.organization.id: 0;
        formattedList.OrganizationText = formattedList.organization ? formattedList.organization.name: ''; 
        const intl = this.props.intl;
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'success',
              notificationMessage: intl.formatMessage({id:"edit.success"}),
              files: []
            });
        this.props.addCurrent(formattedList);
        this.componentDidMount();
 
          }
          else{
            const intl = this.props.intl;
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage:  result.data.errors && result.data.errors[0] ? result.data.errors[0] : intl.formatMessage({id:"process.error"})
            });

          }
        })
        .catch(err => {
          if(err.response && err.response.data && err.response.data.errors){
            const intl = this.props.intl;
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({id:"process.error"})
            });
          }
          else{
            const intl = this.props.intl;
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: intl.formatMessage({id:"process.error"})
            });
          }
        });
  };

  closeNotification() {
    this.setState({ openNotification: false });
  }

  async changeValues(stateName, value, text = '') {
    this.setState({ loading: true });

    this.setState(prevState => ({
      techinicalteamorganizationcategory: {
        ...prevState.techinicalteamorganizationcategory,
        [stateName]: value
      }
    }));
        if(stateName === 'OrganizationCategoryId'){
          this.setState(prevState => ({
            techinicalteamorganizationcategory: {
              ...prevState.techinicalteamorganizationcategory,
              ['OrganizationCategoryText']: text,
            }
          }));
        }
        if(stateName === 'TechinicalTeamId'){
          this.setState(prevState => ({
            techinicalteamorganizationcategory: {
              ...prevState.techinicalteamorganizationcategory,
              ['TechinicalTeamText']: text,
            }
          }));
        }
     if(stateName === 'OrganizationId'){
          this.setState(prevState => ({
            item: {
              ...prevState.item,
              ['OrganizationText']: text,
            }
          }));
          await this.getCategories(value);
          await this.getTechinicalTeams(value);
  
    }

    this.setState({ loading: false });

  };

  removeItem(file) {
    let array = [...this.state.files];
    let index = array.indexOf(file)
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ files: array });
    }
  }

    render() {
    const { classes, headerMenu, actionsHeaderMenu, techinicalteamorganizationcategories } = this.props;
    const { techinicalteamorganizationcategory } = this.state;
    const intl = this.props.intl;

    if(Api == null) {
      var l = this.props.match.params.lang;
      document.location.href=`/${l}/unavailable`
    }

     return (
      <div className={classes.root}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}
        >
          <div className={classes.drawerHeader} />

          <Container component='main' maxWidth='md'>
            <CssBaseline />
            <div className={classes.paper} style={{ marginTop: 0 }}>
              <Grid container spacing={6}>
                <Grid item xs={12} sm={4}>
                    <Button variant='outlined' color='primary'  onClick={browserHistory.goBack}>{<FormattedMessage id="back" />}</Button>
                </Grid>
                <Grid item xs={12} sm={8} />
              </Grid>
              <Avatar className={classes.avatar}>
                <QueuePlayNext />
              </Avatar>
              <Typography component='h1' variant='h5'>
              {<FormattedMessage id="edit.item" />}
              <Title />
              </Typography>
              <form name='myForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                      <SimpleSelect label={intl.formatMessage({id:"organization"})} options={this.state.OrganizationList} stateName='OrganizationId' changeSelect={this.changeValues} selected={techinicalteamorganizationcategory.OrganizationId} />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <SimpleAutoComplete label={intl.formatMessage({id:"category"})} name='organizationcategoryid'  options={this.state.OrganizationCategoryList} stateName='OrganizationCategoryId' changeSelect={this.changeValues} selected={techinicalteamorganizationcategory.OrganizationCategoryId} />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <SimpleSelect label={intl.formatMessage({id:"team"})} name='techinicalteamid'  options={this.state.TechinicalTeamList} stateName='TechinicalTeamId' changeSelect={this.changeValues} selected={techinicalteamorganizationcategory.TechinicalTeamId} />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <Grid container justify="flex-end" style={{ justifyContent: 'flex-end' }}>
                  <Grid item xs={12} sm={4}    >
                    <Button 
                      type='submit'
                      fullWidth
                      variant='contained'
                      color='primary'
                      className={classes.submit}
                    
                    >
                      {<FormattedMessage id="save" />}
                    </Button>
                  </Grid>
                </Grid>
                </Grid>
                </Grid>
              </form>
            </div>

            {this.state.loading && (
              <Overlay>
                <CircularProgress color='secondary' />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification}
            />
          </Container>
        </main>
        <Footer />                    
     </div>
    );
  }
}
TechinicalTeamOrganizationCategoryEdit.propTypes = {
                    classes: PropTypes.object.isRequired
                };
                const mapStateToProps = state => ({
                  actionsHeaderMenu: state.actionsHeaderMenu,
                    headerMenu: state.headerMenu,
                    userSession: state.userSession,
                    techinicalteamorganizationcategories: state.techinicalteamorganizationcategories
                });
                const mapDispatchToProps = dispatch =>
                    bindActionCreators(componentActions, dispatch);

            export default injectIntl(connect(mapStateToProps,mapDispatchToProps)(withStyles(Styles)(TechinicalTeamOrganizationCategoryEdit)));
